/* eslint-disable no-tabs */
import { endpoints } from '../../Constants';
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const processFlowServices = {
	gateway,
	fetchNodes,
	fetchAvailableNodes,
	fetchAvailableSections,
	saveNodes,
	addNode,
	fetchAnalytics,
	fetchAnalyticsShiftwise,
	fetchDailyStatsSummary,
	fetchRetailOrdersIds,
	addSection,
	edgeDelete,
	nodeDelete,
	nodeEdit,
	fetchStatsSummary,
	fetchOperationAnalytics,
};

function gateway({ req, method }) {
	switch (method) {
		case 'LIST':
			return fetchNodes(req);
		default:
			break;
	}
	return new Promise();
}
function edgeDelete(req = {}) {
	const { params = {} } = req;
	const url = toQueryStringURL(endpoints.PROCESS_FLOW_EDGE_DELETE, params);
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function nodeDelete(req = {}) {
	const { params = {} } = req;
	const url = toQueryStringURL(endpoints.PROCESS_FLOW_NODE_DELETE, params);
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function nodeEdit(req = {}) {
	const { params = {} } = req;
	const url = toQueryStringURL(endpoints.PROCESS_FLOW_NODE_EDIT, params);
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}
function fetchNodes(req = {}) {
	const { params = {} } = req;
	const url = toQueryStringURL(endpoints.PROCESS_FLOW_NODES, params);
	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
	// return mockFetch1(url, requestOptions);
}
function fetchAvailableNodes() {
	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(endpoints.PROCESS_FLOW_AVAILABLE_NODES, requestOptions).then(
		handleResponse
	);
	// return mockFetch1(url, requestOptions);
}
function fetchAvailableSections(req = {}) {
	const { params = {} } = req;
	const url = toQueryStringURL(
		endpoints.PROCESS_FLOW_AVAILABLE_SECTIONS,
		params
	);
	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
	// return mockFetch1(url, requestOptions);
}

function saveNodes(req) {
	const { params = {} } = req;
	const url = toQueryStringURL(endpoints.PROCESS_FLOW_SAVE, params);
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	// return mockOHList(requestOptions);
	return fetch(url, requestOptions).then(handleResponse);
}

function addNode(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	// return mockOHList(requestOptions);
	return fetch(endpoints.PROCESS_FLOW_ADD, requestOptions).then(
		handleResponse
	);
}
function fetchAnalytics(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	// return mockOHList(requestOptions);
	return fetch(endpoints.PROCESS_FLOW_ANALYTICS, requestOptions).then(
		handleResponse
	);
}

function fetchOperationAnalytics(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	// return mockOHList(requestOptions);
	return fetch(endpoints.OPERATION_PROCESS_FLOW_ANALYTICS, requestOptions).then(
		handleResponse
	);
}
function fetchAnalyticsShiftwise(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	// return mockOHList(requestOptions);
	return fetch(
		endpoints.PROCESS_FLOW_ANALYTICS_SHIFTWISE,
		requestOptions
	).then(handleResponse);
}

function fetchRetailOrdersIds(req) {
	// TODO: Implement actual API call when backend is ready
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(
		endpoints.PROCESS_FLOW_DISTRIBUTION_SUMMARY,
		requestOptions
	).then(handleResponse);

	// Placeholder function - returns mock data for now
	// return new Promise((resolve) => {
	// 	setTimeout(() => {
	// 		resolve({
	// 			responseCode: 'SS-001',
	// 			data: {
	// 				orderIds: [],
	// 				statsSummary: {
	// 					orderedCost: 100,
	// 					fulfilledCost: 90,
	// 				},
	// 			},
	// 		});
	// 	}, 1000);
	// });
}

function fetchDailyStatsSummary() {
	// TODO: Implement actual API call when backend is ready
	// const requestOptions = {
	//   method: 'POST',
	//   headers: {
	//     ...authHeader(),
	//     'Content-Type': 'application/json',
	//   },
	//   body: JSON.stringify({
	//     ...req?.data,
	//   }),
	// };
	// return fetch(endpoints.PROCESS_FLOW_DAILY_STATS_SUMMARY, requestOptions).then(handleResponse);

	// Placeholder function - returns mock data for now
	return new Promise((resolve) => {
		setTimeout(() => {
			resolve({
				responseCode: 'SS-001',
				data: {
					statsSummary: [
						{
							name: 'Issued Value',
							fulfilledCost:
								Math.floor(Math.random() * 5000) + 1000,
							orderedCost:
								Math.floor(Math.random() * 10000) + 5000,
							type: 'upper',
						},
						{
							name: 'Produced Value',
							fulfilledCost:
								Math.floor(Math.random() * 7000) + 2000,
							orderedCost:
								Math.floor(Math.random() * 10000) + 5000,
							type: 'upper',
						},
						{
							name: 'Dispatched Value',
							fulfilledCost:
								Math.floor(Math.random() * 3000) + 500,
							orderedCost:
								Math.floor(Math.random() * 10000) + 5000,
							type: 'upper',
						},
						{
							name: 'Shift 1: Breakfast',
							fulfilledCost:
								Math.floor(Math.random() * 4000) + 1000,
							orderedCost:
								Math.floor(Math.random() * 5000) + 2000,
							type: 'bottom',
						},
						{
							name: 'Shift 2: Lunch',
							fulfilledCost:
								Math.floor(Math.random() * 6000) + 2000,
							orderedCost:
								Math.floor(Math.random() * 8000) + 3000,
							type: 'bottom',
						},
						{
							name: 'Shift 3: Dinner',
							fulfilledCost:
								Math.floor(Math.random() * 5000) + 1500,
							orderedCost:
								Math.floor(Math.random() * 7000) + 2500,
							type: 'bottom',
						},
					],
				},
			});
		}, 1000);
	});
}

function addSection(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	// return mockOHList(requestOptions);
	return fetch(endpoints.PROCESS_FLOW_ADD_SECTION, requestOptions).then(
		handleResponse
	);
}

function fetchStatsSummary(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.OPS_FLOW_STATS, requestOptions).then(
		handleResponse
	);
}

export default processFlowServices;
